import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

export type DocumentValidatedAction = {
	type: 'DOCUMENT_VALIDATED';
	payload: DocumentDetailPayload;
};

export default (payload: DocumentDetailPayload): DocumentValidatedAction => ({
	type: 'DOCUMENT_VALIDATED',
	payload,
});
